import { render } from "./EndnoteGroup.vue?vue&type=template&id=4e67dcff&scoped=true"
import script from "./EndnoteGroup.vue?vue&type=script&lang=js"
export * from "./EndnoteGroup.vue?vue&type=script&lang=js"

import "./EndnoteGroup.vue?vue&type=style&index=0&id=4e67dcff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e67dcff"]])

export default __exports__